export default function Notice({ variant = 'band' }) {
  if (variant === 'band') {
    return (
      <div data-testid="transparency-band" className="bg-[#FEF2F2] border-y border-[#FCA5A5]">
        <div className="mx-auto max-w-6xl px-5 py-4 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
          <span className="font-pricemono text-xs font-semibold tracking-widest text-[#991B1B] uppercase shrink-0">
            Catatan Transparansi
          </span>
          <p className="text-sm text-[#991B1B] leading-relaxed">
            Seluruh produk Ayam Goreng Widuran adalah <strong>non-halal</strong>. Sejak Mei 2025 kami
            mencantumkan label ini secara terbuka di outlet dan kemasan, agar setiap pelanggan dapat
            memilih dengan sadar dan nyaman.
          </p>
        </div>
      </div>
    );
  }
  return (
    <aside
      data-testid="transparency-box"
      className="rounded-lg border border-[#FCA5A5] bg-[#FEF2F2] p-5"
    >
      <h3 className="font-pricemono text-xs font-semibold tracking-widest text-[#991B1B] uppercase">
        Catatan Transparansi
      </h3>
      <p className="mt-2 text-sm leading-relaxed text-[#991B1B]">
        Produk kami non-halal. Informasi ini kami sampaikan terbuka demi kenyamanan dan kepercayaan
        seluruh pelanggan.
      </p>
    </aside>
  );
}
